import script from "./EditMemberAccountForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMemberAccountForm.vue?vue&type=script&setup=true&lang=js"

import "./EditMemberAccountForm.vue?vue&type=style&index=0&id=1b807d54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b807d54"]])

export default __exports__